import React, { useState, useMemo } from 'react';
import { newsArticles } from '../data/newsData';

const NewsPage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('todas');
  const [selectedType, setSelectedType] = useState<string>('todas');
  const [searchTerm, setSearchTerm] = useState<string>('');

  // Categorías únicas de las noticias
  const categories = useMemo(() => {
    const cats = Array.from(new Set(newsArticles.map(article => article.category)));
    return ['todas', ...cats];
  }, []);

  // Filtrar noticias
  const filteredNews = useMemo(() => {
    let filtered = newsArticles;

    // Filtro por categoría
    if (selectedCategory !== 'todas') {
      filtered = filtered.filter(article => article.category === selectedCategory);
    }

    // Filtro por tipo
    if (selectedType !== 'todas') {
      filtered = filtered.filter(article => 
        selectedType === 'técnica' ? article.isTechnical : !article.isTechnical
      );
    }

    // Filtro por búsqueda
    if (searchTerm) {
      filtered = filtered.filter(article =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }

    return filtered;
  }, [selectedCategory, selectedType, searchTerm]);

  return (
    <div className="page-wrapper">
      <main className="page-main">
        <div style={{ marginTop: '-100px', minHeight: '100vh' }}>
          {/* Header de la página */}
          <div 
            className="uk-section uk-light"
            style={{
              background: 'linear-gradient(135deg, #20D3C7 0%, #17BCBA 100%)',
              padding: '80px 0 40px 0',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Elementos decorativos de fondo */}
            <div style={{
              position: 'absolute',
              top: '-50%',
              right: '-10%',
              width: '300px',
              height: '300px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%',
              transform: 'rotate(45deg)'
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30%',
              left: '-5%',
              width: '200px',
              height: '200px',
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '50%'
            }}></div>
            
            <div className="uk-container uk-container-large">
              <div className="uk-text-center">
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: 'rgba(255, 255, 255, 0.2)',
                  padding: '12px 24px',
                  borderRadius: '50px',
                  marginBottom: '20px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  <i className="fas fa-newspaper" style={{ 
                    color: 'white', 
                    fontSize: '20px',
                    marginRight: '10px'
                  }}></i>
                  <span style={{ 
                    color: 'white', 
                    fontSize: '14px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>
                    Noticias Argentinas
                  </span>
                </div>
                <h1 style={{ 
                  color: 'white', 
                  fontSize: '48px',
                  fontWeight: '700',
                  marginBottom: '20px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  Últimas Noticias del Sector
                </h1>
                <p style={{ 
                  color: 'rgba(255, 255, 255, 0.95)', 
                  fontSize: '18px',
                  maxWidth: '600px',
                  margin: '0 auto',
                  lineHeight: '1.6',
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                  Mantente informado sobre las últimas tendencias, innovaciones y novedades del sector industrial en Argentina
                </p>
              </div>
            </div>
          </div>

          {/* Filtros y búsqueda */}
          <div className="uk-section" style={{ padding: '40px 0' }}>
            <div className="uk-container uk-container-large">
              <div className="uk-grid uk-child-width-1-3@m uk-child-width-1-1@s" data-uk-grid style={{ gap: '20px' }}>
                {/* Búsqueda */}
                <div>
                  <div style={{ position: 'relative' }}>
                    <i className="fas fa-search" style={{
                      position: 'absolute',
                      left: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#666',
                      zIndex: 1
                    }}></i>
                    <input
                      type="text"
                      placeholder="Buscar noticias..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 15px 12px 45px',
                        border: '2px solid #e5e5e5',
                        borderRadius: '25px',
                        fontSize: '14px',
                        transition: 'all 0.3s ease',
                        background: 'white'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#20D3C7';
                        e.target.style.boxShadow = '0 0 0 3px rgba(32, 211, 199, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e5e5e5';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                {/* Filtro por categoría */}
                <div>
                  <select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '2px solid #e5e5e5',
                      borderRadius: '25px',
                      fontSize: '14px',
                      background: 'white',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#20D3C7';
                      e.target.style.boxShadow = '0 0 0 3px rgba(32, 211, 199, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e5e5e5';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {categories.map(category => (
                      <option key={category} value={category}>
                        {category === 'todas' ? 'Todas las categorías' : category}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Filtro por tipo */}
                <div>
                  <select
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '2px solid #e5e5e5',
                      borderRadius: '25px',
                      fontSize: '14px',
                      background: 'white',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#20D3C7';
                      e.target.style.boxShadow = '0 0 0 3px rgba(32, 211, 199, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e5e5e5';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <option value="todas">Todos los tipos</option>
                    <option value="técnica">Noticias técnicas</option>
                    <option value="color">Noticias de color</option>
                  </select>
                </div>
              </div>

              {/* Contador de resultados */}
              <div className="uk-text-center" style={{ marginTop: '30px' }}>
                <div style={{
                  display: 'inline-block',
                  background: 'rgba(32, 211, 199, 0.1)',
                  padding: '8px 20px',
                  borderRadius: '20px',
                  border: '1px solid rgba(32, 211, 199, 0.2)'
                }}>
                  <span style={{ 
                    color: '#20D3C7', 
                    fontSize: '14px',
                    fontWeight: '600'
                  }}>
                    {filteredNews.length} noticia{filteredNews.length !== 1 ? 's' : ''} encontrada{filteredNews.length !== 1 ? 's' : ''}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Grid de noticias */}
          <div className="uk-section" style={{ 
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            padding: '60px 0'
          }}>
            <div className="uk-container uk-container-large">
              {filteredNews.length > 0 ? (
                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                  gap: '30px',
                  width: '100%'
                }}>
                  {filteredNews.map((article) => (
                    <div key={article.id}>
                      <div className="uk-card uk-card-default uk-card-hover uk-card-body uk-border-rounded" 
                           style={{ 
                             border: '1px solid #e5e5e5',
                             boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                             transition: 'all 0.3s ease',
                             height: '100%',
                             background: 'white',
                             display: 'flex',
                             flexDirection: 'column'
                           }}
                           onMouseEnter={(e) => {
                             e.currentTarget.style.transform = 'translateY(-5px)';
                             e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                           }}
                           onMouseLeave={(e) => {
                             e.currentTarget.style.transform = 'translateY(0)';
                             e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                           }}>
                        
                        {/* Imagen de la noticia */}
                        <div style={{ position: 'relative', marginBottom: '15px', flexShrink: 0 }}>
                          <img 
                            src={article.image} 
                            alt={article.title}
                            className="uk-border-rounded"
                            style={{ 
                              width: '100%', 
                              height: '200px', 
                              objectFit: 'cover'
                            }}
                          />
                          {/* Badge de tipo de noticia */}
                          <div style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            background: article.isTechnical 
                              ? 'linear-gradient(135deg, #20D3C7, #17BCBA)' 
                              : 'linear-gradient(135deg, #FF6B6B, #FF8E53)',
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '10px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                          }}>
                            {article.isTechnical ? 'Técnica' : 'Color'}
                          </div>
                          {/* Tiempo de lectura */}
                          <div style={{
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                            background: 'rgba(0,0,0,0.7)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '15px',
                            fontSize: '10px',
                            backdropFilter: 'blur(10px)'
                          }}>
                            <i className="fas fa-clock" style={{ marginRight: '4px' }}></i>
                            {article.readTime} min
                          </div>
                        </div>

                        {/* Contenido de la noticia */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '0 15px 15px 15px' }}>
                          <h3 style={{ 
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#333',
                            marginBottom: '10px',
                            lineHeight: '1.4'
                          }}>
                            {article.title}
                          </h3>
                          
                          <p style={{ 
                            fontSize: '14px',
                            color: '#666',
                            lineHeight: '1.5',
                            marginBottom: '15px',
                            flex: 1
                          }}>
                            {article.excerpt}
                          </p>

                          {/* Meta información */}
                          <div style={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontSize: '12px',
                            color: '#888',
                            marginBottom: '15px'
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <i className="fas fa-user" style={{ marginRight: '5px' }}></i>
                              {article.author}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <i className="fas fa-calendar" style={{ marginRight: '5px' }}></i>
                              {new Date(article.publishedDate).toLocaleDateString('es-AR', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              })}
                            </div>
                          </div>

                          {/* Fuente */}
                          <div style={{ 
                            fontSize: '12px',
                            color: '#20D3C7',
                            fontWeight: '600',
                            marginBottom: '15px'
                          }}>
                            <i className="fas fa-building" style={{ marginRight: '5px' }}></i>
                            {article.url ? (
                              <a 
                                href={article.url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: 'inherit',
                                  textDecoration: 'none',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.textDecoration = 'underline';
                                  e.currentTarget.style.transform = 'translateX(2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.textDecoration = 'none';
                                  e.currentTarget.style.transform = 'translateX(0)';
                                }}
                              >
                                {article.source}
                                <i className="fas fa-external-link-alt" style={{ 
                                  marginLeft: '5px', 
                                  fontSize: '10px',
                                  opacity: '0.7'
                                }}></i>
                              </a>
                            ) : (
                              article.source
                            )}
                          </div>

                          {/* Tags */}
                          <div style={{ marginBottom: '15px' }}>
                            {article.tags.slice(0, 3).map((tag, tagIndex) => (
                              <span key={tagIndex} style={{
                                display: 'inline-block',
                                background: '#f0f0f0',
                                color: '#666',
                                padding: '3px 8px',
                                borderRadius: '12px',
                                fontSize: '10px',
                                marginRight: '6px',
                                marginBottom: '5px'
                              }}>
                                #{tag}
                              </span>
                            ))}
                          </div>

                          {/* Botón de leer más */}
                          <div style={{ marginTop: 'auto' }}>
                            {article.url ? (
                              <a 
                                href={article.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="uk-button uk-button-primary"
                                style={{ 
                                  background: 'linear-gradient(135deg, #20D3C7, #17BCBA)',
                                  border: 'none',
                                  borderRadius: '25px',
                                  padding: '12px 24px',
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  transition: 'all 0.3s ease',
                                  textDecoration: 'none',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  width: '100%',
                                  justifyContent: 'center',
                                  color: 'white'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(32, 211, 199, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = 'none';
                                }}
                              >
                                <i className="fas fa-external-link-alt uk-margin-small-right" style={{ color: 'white' }}></i>
                                <span style={{ color: 'white' }}>Leer completo</span>
                              </a>
                            ) : (
                              <button className="uk-button uk-button-primary"
                                      style={{ 
                                        background: 'linear-gradient(135deg, #20D3C7, #17BCBA)',
                                        border: 'none',
                                        borderRadius: '25px',
                                        padding: '12px 24px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        transition: 'all 0.3s ease',
                                        width: '100%',
                                        color: 'white'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(32, 211, 199, 0.4)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                      }}>
                                <i className="fas fa-arrow-right uk-margin-small-right"></i>
                                Leer más
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="uk-text-center">
                  <div style={{ 
                    padding: '60px 20px',
                    background: 'rgba(255, 255, 255, 0.8)',
                    borderRadius: '20px',
                    border: '1px solid rgba(32, 211, 199, 0.2)',
                    maxWidth: '600px',
                    margin: '0 auto'
                  }}>
                    <div style={{ 
                      width: '100px', 
                      height: '100px', 
                      margin: '0 auto 30px',
                      background: 'linear-gradient(135deg, #20D3C7, #17BCBA)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <i className="fas fa-search" style={{ 
                        fontSize: '36px', 
                        color: 'white'
                      }}></i>
                    </div>
                    <h3 style={{ 
                      color: '#333', 
                      fontSize: '24px',
                      fontWeight: '600',
                      marginBottom: '15px'
                    }}>
                      No se encontraron noticias
                    </h3>
                    <p style={{ 
                      color: '#666', 
                      fontSize: '16px',
                      lineHeight: '1.6'
                    }}>
                      Intenta ajustar los filtros o términos de búsqueda para encontrar más noticias.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NewsPage;
